<template>
  <div class="row m-2 m-sm-4 font-italic">
    <div class="col flex-grow-1 flex-sm-grow-0 site-title-div text-nowrap">
      <div>
        <h1>Админ<strong>ПЛЮС</strong></h1>
        <h2><strong>електронен дневник</strong></h2>
      </div>
    </div>

    <div class="col col-sm-6 flex-grow-1 flex-sm-grow-0 align-self-end text-right text-sm-left">
      <div>
        <h2><strong>ДЕН НА НАРОДНИТЕ БУДИТЕЛИ</strong></h2>
        <h4>„И не забравяйте – Времето е в нас и ние сме във времето,
          то нас обръща и ние него обръщаме.“</h4>
        <h5 class="text-right">Васил Левски</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "november1st-main-component"
}
</script>

<style scoped>

</style>
